import { createContext } from "react";
import Notification from "rc-notification";
let notification;

Notification.newInstance({}, (instance) => { notification = instance; });

export const NotificationContext = createContext(notification);
